import React, {  useState } from "react";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import Notification from "../notification/Notification";
import { useTranslation } from "react-i18next";

const WebhookActionsSelect = ({ checkedAction, setCheckedAction, name, defaultOption = false }) => {
  const { t } = useTranslation("otherInterface");

  const [actionList, setActionList] = useState(['onFeeUpdate']);

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  const handleChangeSelect = (e) => {
    let data = e.target.value;
    setCheckedAction(data);
  };

  if (Object.keys(actionList).length === 0) {
    return "Empty Webhook Actions";
  }

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <FormControl>
        <InputLabel id="service-simple-select-label">{t("webhookActionsSelect.title")}</InputLabel>
        {/* No need to change on Autocomplete component (few options) */}
        <Select
          labelId="webhook-actions-simple-select-label"
          id="webhook-actions-simple-select"
          value={checkedAction}
          name={name}
          onChange={handleChangeSelect}
        >
          {defaultOption && <MenuItem value={null}>{t("webhookActionsSelect.all")}</MenuItem>}
          {actionList.map((action,key) => (
            <MenuItem
              key={action}
              value={action}
            >
              {action}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </>
  );
};

export default WebhookActionsSelect;